import { sortBy } from 'lodash'
import type { Proc_Procedure } from './Proc.Procedure'
import { Proc_fetchAll, Proc_fetchExistingAssigned } from './Proc.fetch'
import { WF_fetch } from '../WF/WF.fetch'
import { pipe } from '../../../shared/lib/functional/pipe.no-deps'
import { promiseThen } from '../../../shared/lib/functional/promiseThen.no-deps'
import { map, flatten, uniq, mapAsync, compact } from '../../../shared/lib/functional/array.no-deps'
import type { ClientLogger } from '../../../shared/lib/ClientLogger.no-deps'
import type { AppUser } from '../../../shared/domain/users/types.no-deps'
import { doesUserHavePermission } from '../User/permissions'

export async function Proc_getProcedures(logger: ClientLogger, user: AppUser): Promise<Proc_Procedure[]> {
    const procedures = doesUserHavePermission(user, 'procedureAdmin')
        ? await Proc_fetchAll()
        : await Proc_fetchExistingAssigned()

    const workflows = await pipe(
        procedures,
        map((p) => p.activityTemplates),
        flatten,
        uniq,
        mapAsync((workflowId) => WF_fetch(logger, workflowId, { includeDeleted: false })),
        promiseThen(compact, (ps) => sortBy(ps, 'name'))
    )

    return procedures.map((procedure) => ({
        id: procedure.id,
        name: procedure.name,
        workflows: workflows.filter((w) => procedure.activityTemplates.includes(w.id)),
    }))
}
